import Vue from 'vue';
import footerForm from './components/footerForm.vue';

new Vue({
    el: 'footer',
    components: {
        footerForm
    }
});


$(() => {
    // Arrow scroll up
    $('.up').click(function () {
        $('body,html').animate({
            scrollTop: 0
        }, 1000);
        return false;
    });

    // nav-mobile
    if ($(window).width() < 1280) {
        $(document).on('click', '.footer-nav-header', function (e) {
            $(this).toggleClass('active').next().slideToggle();
            $('.footer-nav-header').not(this).removeClass('active').next().slideUp();
        });
    }
});